@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as m;

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px;
    background-color: v.$palette-white;
    border-radius: 16px;
    box-shadow: v.$shadow2;
    flex-wrap: wrap;

    @include m.media(v.$container-tablet, "min") {
        flex-wrap: nowrap;
        gap: 20px;
        padding: 24px;
    }

    @include m.media(840, "min") {
        gap: 56px;
    }
}

.logoBox {
    display: flex;
    align-items: center;
    gap: 12px;
    order: 1;
    flex: 1 1 auto;
    min-width: 0;

    @include m.media(v.$container-tablet, "min") {
        order: unset;
        flex: 0 1 auto;
        max-width: 42%;
        gap: 16px;
    }

    @include m.media(840, "min") {
        flex: 0 0 auto;
        max-width: none;
    }

    .appName {
        margin: 0;
        @include t.text(16px, 24px, 600);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: v.$palette-orange-2;

        @include m.media(v.$container-tablet, "min") {
            @include t.text(18px, 28px, 600);
        }
    }

    .logo {
        width: 32px;
        flex-shrink: 0;

        @include m.media(v.$container-tablet, "min") {
            width: 35px;
        }
    }
}

.stepBox {
    flex-grow: 1;
    order: 3;
    flex-basis: 100%;
    min-width: 0;

    @include m.media(v.$container-tablet, "min") {
        order: unset;
        flex: 1 1 auto;
        flex-basis: unset;
    }

    .stepWrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        gap: 8px;
        margin-bottom: 10px;
    }

    .step {
        @include t.text(12px, 18px, 600);
        color: v.$palette-dirty-50;
        white-space: nowrap;

        @include m.media(840, "min") {
            @include t.text(16px, 26px, 600);
        }

        &.active {
            color: v.$default-text-color;
        }
    }

    .progress {
        width: 100%;
        border-radius: 4px;
        background-color: v.$palette-dirty-50;

        .line {
            height: 6px;
            border-radius: 4px;
            background-color: v.$palette-orange-2;
            transition: v.$transition;

            &.start {
                width: 13%;
            }
            &.half {
                width: 50%;
            }
            &.end {
                width: 100%;
            }
        }
    }
}

.btnBox {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: nowrap;
    gap: 8px;
    order: 2;
    flex: 0 0 auto;

    @include m.media(v.$container-tablet, "min") {
        order: unset;
    }

    .nextButton {
        background-color: v.$palette-orange-2;
    
        &:hover {
            background-color: v.$palette-orange-3;
        }
    }
}
